/* unplugin-vue-components disabled */import script from "./FileSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FileSelect.vue?vue&type=script&setup=true&lang=js"

import "./FileSelect.vue?vue&type=style&index=0&id=6038f015&lang=stylus"

const __exports__ = script;

export default __exports__